/******/ (() => { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ "./zrc/scripts/base.js":
/*!*****************************!*\
  !*** ./zrc/scripts/base.js ***!
  \*****************************/
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var _general_search_suggestions__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(/*! ./general/search-suggestions */ "./zrc/scripts/general/search-suggestions.js");
/* harmony import */ var _general_search_suggestions__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_general_search_suggestions__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _layouts_header__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(/*! ./layouts/header */ "./zrc/scripts/layouts/header.js");
/* harmony import */ var _layouts_header__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(_layouts_header__WEBPACK_IMPORTED_MODULE_1__);



/***/ }),

/***/ "./zrc/scripts/general/search-suggestions.js":
/*!***************************************************!*\
  !*** ./zrc/scripts/general/search-suggestions.js ***!
  \***************************************************/
/***/ (() => {

var general = {
  search() {
    // $('.site-header__search-toggle').on('click', (event) => {
    //   event.preventDefault();
    //   $('body, html, .page-container').addClass('js-drawer-open');
    //   $('.boost-pfs-search-suggestion-mobile-overlay').show();
    //   $('.boost-pfs-search-suggestion-mobile-top-panel').show();
    //   $('#boost-pfs-search-box-mobile').trigger('focus');

    // });

    // $('.search-bar .js-drawer-close').on('click', () => {
    //   CloseAll();
    // });

    // // eslint-disable-next-line shopify/prefer-early-return
    // $('.page-container').on('click', function() {
    //   if ($(this).hasClass('js-drawer-open')) {
    //     $('.boost-pfs-search-suggestion-mobile-top-panel').hide();
    //     $(this).add('body').add('html')
    //       .removeClass('js-drawer-open');
    //   }
    // });

    // $(window).load(() => {
    //   window.setTimeout(() => {
    //     $('.boost-pfs-search-btn-close-suggestion').on('click', () => {
    //       $('.boost-pfs-search-suggestion-mobile-top-panel').hide();
    //       $('.page-container')
    //         .add('.site-header__search-toggle')
    //         .add('body')
    //         .add('html')
    //         .removeClass('js-drawer-open');
    //       $('.page-container').trigger('click');
    //       // $('.boost-pfs-search-btn-close-suggestion').trigger('click');
    //       theme.SearchDrawer.close();
    //       $('ul.boost-pfs-search-suggestion ').hide();
    //     });

    //     $('.boost-pfs-search-btn-clear-suggestion').on('click', () => {
    //       $('ul.boost-pfs-search-suggestion ').hide();
    //     });
    //   }, 1000);
    // });

    function CloseAll() {
      $('.boost-pfs-search-suggestion-wrapper').attr('style', '');
      $('.boost-pfs-search-suggestion ').hide();
      $('ul.boost-pfs-search-suggestion ').hide();
      $('.boost-pfs-search-suggestion-popover ').hide();
      $('.boost-pfs-search-suggestion-mobile-top-panel').hide();
      $('.boost-pfs-search-suggestion-mobile-overlay').hide();
      $('#PageContainer').removeClass('.js-drawer-open');
      $('body').removeClass('.boost-pfs-search-suggestion-mobile-open');
      $('.boost-pfs-search-btn-close-suggestion').trigger('click');
      theme.SearchDrawer.close();
      return false;
    }

    // $(window).on('scroll', () => {
    //   CloseAll();
    // });

    // $(window).on('resize', () => {
    //   if ($(document.activeElement).attr('type') !== 'text') {
    //     CloseAll();
    //   }
    // });

    // enquire.register('(max-width: 767px)', {
    //   match: () => {
    //     CloseAll();
    //   },
    // });

    // enquire.register('(min-width: 768px)', {
    //   match: () => {
    //     CloseAll();
    //   },
    // });

    $(window).on('scroll', () => {
      enquire.register('(min-width: 768px)', {
        match: () => {
          CloseAll();
        }
      });
    });
    $(window).on('resize', () => {
      if ($(document.activeElement).attr('type') !== 'text') {
        enquire.register('(min-width: 768px)', {
          match: () => {
            CloseAll();
          }
        });
      }
    });
    enquire.register('(max-width: 767px)', {
      match: () => {
        CloseAll();
      }
    });
  },
  init() {
    this.search();
  }
};
window.addEventListener('load', () => {
  general.init();
});

/***/ }),

/***/ "./zrc/scripts/layouts/header.js":
/*!***************************************!*\
  !*** ./zrc/scripts/layouts/header.js ***!
  \***************************************/
/***/ (() => {

class Header extends window.HTMLElement {
  constructor() {
    super();
    this.container = this;
    this.isResizing = false;
    this.megaMenuRemoveHiden();
    document.addEventListener('rebuy.ready', this.setSmartCartBlock.bind(this));
    this.delayHoverInlinks();
    var headerHomepage = $('.header').hasClass('is-homepage');
    if (headerHomepage) {
      this.changeOnScroll();
      this.changeOnHover();
    }
    this.getViewportHeight();
    this.addEventResize();
  }
  megaMenuRemoveHiden() {
    window.setTimeout(() => {
      $('.megamenu').removeClass('initially-hidden-menu');
    }, 700);
  }
  changeOnScroll() {
    var header = $('.header');
    function headerScroll() {
      if (window.scrollY > 20) {
        header.removeClass('without-scroll');
        header.removeClass('header-homepage');
        header.addClass('on-scroll');
      } else {
        header.addClass('without-scroll');
        header.removeClass('on-scroll');
        if ($('.navigation-submenu:hover').length) {
          header.removeClass('without-scroll');
        } else {
          header.addClass('without-scroll');
        }
      }
    }
    headerScroll();
    window.addEventListener('scroll', headerScroll);
  }
  changeOnHover() {
    var timeout;
    $('.navigation-submenu').hover(() => {
      window.clearTimeout(timeout);
      window.setTimeout(() => {
        $('.header').removeClass('header-homepage');
        $('.header').removeClass('without-scroll');
      }, 300);
    }, () => {
      if ($('.header').hasClass('on-scroll')) {
        $('.header').removeClass('header-homepage');
      } else {
        timeout = window.setTimeout(() => {
          $('.header').addClass('header-homepage');
        }, 300);
      }
    });
  }
  delayHoverInlinks() {
    var submenuWrapper = document.querySelectorAll('.navigation-submenu');
    submenuWrapper.forEach(element => {
      var interval;
      element.addEventListener('mouseenter', () => {
        element.classList.add('js-delay-hover');
        if (interval) {
          window.clearInterval(interval);
        }
      });
      element.addEventListener('mouseleave', () => {
        interval = window.setInterval(() => {
          element.classList.remove('js-delay-hover');
        }, 300);
      });
    });
  }
  getViewportHeight() {
    if (window.innerWidth <= 800) {
      var vh = window.innerHeight;
      var height = document.querySelector('.announcement-bar-section').offsetHeight;
      document.documentElement.style.setProperty('--vh', "".concat(vh, "px"));
      document.documentElement.style.setProperty('--announcement-bar-height', "".concat(height, "px"));
    }
    return false;
  }
  addEventResize() {
    window.addEventListener('resize', () => {
      this.isResizing = true;
      this.getViewportHeight();
    });
  }
  setSmartCartBlock() {
    var smartCart = document.querySelectorAll('.shiptection-widget');
    if (smartCart.length > 0) {
      var rebuyCheckout = document.querySelectorAll('#rebuy-cart div[data-rebuy-component=checkout-area]');
      if (rebuyCheckout.length > 0) {
        rebuyCheckout[0].appendChild(smartCart[0]);
      }
    }
  }
}
if (window.customElements.get('header-section') == null) {
  window.customElements.define('header-section', Header);
}

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		if(__webpack_module_cache__[moduleId]) {
/******/ 			return __webpack_module_cache__[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			// no module.id needed
/******/ 			// no module.loaded needed
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	(() => {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = (module) => {
/******/ 			var getter = module && module.__esModule ?
/******/ 				() => (module['default']) :
/******/ 				() => (module);
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	(() => {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = (exports, definition) => {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	(() => {
/******/ 		__webpack_require__.o = (obj, prop) => (Object.prototype.hasOwnProperty.call(obj, prop))
/******/ 	})();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	(() => {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = (exports) => {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	})();
/******/ 	
/************************************************************************/
/******/ 	// startup
/******/ 	// Load entry module
/******/ 	__webpack_require__("./zrc/scripts/base.js");
/******/ 	// This entry module used 'exports' so it can't be inlined
/******/ })()
;